<template>
<v-container class="pt-4 pb-12 py-sm-12 px-4 px-sm-0">
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

<v-row class="mb-4">   
  <v-col cols="12" class="px-4 py-0">
    <div class="title-container d-flex justify-space-between align-center">
  <div>
  <span class="page-title">{{ page.title }}</span>
  <v-breadcrumbs class="app-breadcrumb mt-0 mt-sm-0" style="margin-top: 2px;" divider="›" :items="[
    { text: 'Homepage', disabled: false, to: '/home', exact: true },
    { text: 'Clientes', disabled: false, to: '/clientes', exact: true },
    { text: 'Incluir Cliente', disabled: true, exact: true }
  ]" />
</div>

      <div class="button-group-desktop d-none d-sm-flex" style="gap: 8px;">
        <v-btn
          elevation="0"
          color="primary"
          outlined
          @click="voltar"
          :disabled="loading"
        >
          Voltar
        </v-btn>

        <v-btn
          elevation="0"
          color="primary"
          dark
          @click="abrirConfirmacao"
          :loading="loading"
        >
          Salvar
        </v-btn>
      </div>
    </div>
  </v-col>
</v-row>

<!-- Botões Mobile — acima de Detalhes do Cliente, igual Máquina -->
<v-row class="d-flex d-sm-none">
  <v-col cols="12">
    <div class="button-group-mobile">
      <v-btn elevation="0" color="primary" outlined @click="voltar" :disabled="loading">
        Voltar
      </v-btn>
      <v-btn elevation="0" color="primary" dark @click="abrirConfirmacao" :loading="loading">
        Salvar
      </v-btn>
    </div>
  </v-col>
</v-row>


<v-form ref="form" v-model="valid" :disabled="loading" class="mt-0">
  <v-row>
    <v-col cols="12" class="px-0 px-sm-3">
      <v-card class="card-form-outlined pa-4 pa-sm-6">
        <v-card-title class="card-group-title px-0 pt-0 pb-4">
          Detalhes do Cliente
        </v-card-title>

        <v-card-text class="px-0 pb-0">
          <v-row>
            <v-col cols="12" sm="6" class="py-2 py-sm-3">
              <v-text-field
                dense
                label="Nome"
                v-model="cliente.nome"
                outlined
                :rules="[rules.required]"
                hide-details="auto"
              />
            </v-col>

            <v-col cols="12" sm="6" class="py-2 py-sm-3">
              <v-text-field
                dense
                label="CPF"
                v-model="cliente.cpf"
                outlined
                v-mask="'###.###.###-##'"
                :rules="[rules.required, rules.cpf]"
                hide-details="auto"
              />
            </v-col>

            <v-col cols="12" sm="6" class="py-2 py-sm-3">
              <v-text-field
                dense
                label="Telefone"
                v-model="cliente.telefone"
                outlined
                v-mask="'(##) #####-####'"
                :rules="[rules.required]"
                hide-details="auto"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-form>


    <v-dialog v-model="dialogConfirmar" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Adicionar Cliente
        </v-card-title>
        <v-card-text>
          Deseja adicionar este cliente?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="dialogConfirmar = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="salvarCliente">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import { eventHub } from "@/main";
import "v-mask/dist/v-mask.min.js";

export default {
  name: "ClienteForm",

  data() {
    return {
      valid: false,
      dialogConfirmar: false,
      operacaoId: null,
      loading: false, 

      page: { title: "Incluir Cliente" },

      cliente: {
        nome: "",
        cpf: "",
        telefone: "",
        email: ""
      },

      rules: {
        required: v => !!v || "Campo obrigatório",
        email: v => /.+@.+\..+/.test(v) || "E-mail inválido",
        cpf: v => /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(v) || "CPF inválido"
      }
    };
  },

  async created() {
    await this.carregarOperacao();
  },

  methods: {
    async carregarOperacao() {
      try {
        const operacaoId = localStorage.getItem("operation");

        if (!operacaoId) {
          throw new Error("Nenhuma operação selecionada no sistema.");
        }

        this.operacaoId = operacaoId;

      } catch (err) {
        this.$dialog.notify.error(err.message || "Erro ao identificar unidade.", {
          position: "top-right",
          timeout: 5000
        });
        this.voltar();
      }
    },

    abrirConfirmacao() {
      if (!this.$refs.form.validate()) return;
      this.dialogConfirmar = true;
    },

    async salvarCliente() {
      this.dialogConfirmar = false;
      this.loading = true;

      try {
        if (!this.operacaoId) {
          throw new Error("Operação não definida.");
        }

        await axios.post("/api/clientes", {
          nome: this.cliente.nome,
          cpf: this.cliente.cpf.replace(/\D/g, ""),
          telefone: this.cliente.telefone.replace(/\D/g, ""),
          email: this.cliente.email,
          operacaoId: this.operacaoId
        });

        eventHub.$emit("CHANGE-OPERATION");

        this.$dialog.notify.info("Cliente cadastrado com sucesso!", {
          position: "top-right",
          timeout: 2000
        });

        this.voltar();

} catch (err) {
  let msg = "Erro ao cadastrar cliente.";

  if (err && err.response && err.response.data) {
    const data = err.response.data;
    if (data.campos && Object.keys(data.campos).length > 0) {
      msg = Object.values(data.campos).join(", ");
    } else if (data.mensagem) {
      msg = data.mensagem;
    }
  } else if (err && err.message) {
    msg = err.message;
  }

  this.$dialog.notify.error(msg, {
    position: "top-right",
    timeout: 5000
        });
      } finally {
        this.loading = false;
      }
    },

    voltar() {
      this.$router.push("/clientes");
    }
  }
};
</script>

<style scoped>
.v-card { border-radius: 12px; }

.title-container { gap: 16px; width: 100%; }

.page-title { font-size: 24px; font-weight: 700; }

.button-group-desktop .v-btn {
  min-width: 130px;
}

/* Mobile — botões lado a lado, mesmo padrão do Detalhes da Máquina */
@media (max-width: 768px) {
  .button-group-mobile {
    display: flex !important;
    width: 100% !important;
    gap: 12px !important;
    margin-top: 8px !important;
    margin-bottom: 16px !important;
  }

  .button-group-mobile .v-btn {
    flex: 1 !important;
    min-width: unset !important;
  }
}
.v-btn { font-weight: 600; text-transform: none; }
.card-group-title { font-size: 16px !important; font-weight: 600; }
</style>